export default [
    {
        text: '',
        align: 'left',
        sortable: false,
        width: '20px'
    },
    {
        text: 'Tipo/Item',
        align: 'left',
        sortable: false,
        value: 'tipo'
    },
    {
        text: 'Descrição',
        align: 'left',
        sortable: false,
        value: 'descricao'
    },
    {
        text: 'Qtd.',
        align: 'left',
        sortable: false,
        value: 'quantidade',
        width: '70px'
    },
    {
        text: 'Marca',
        align: 'left',
        sortable: false,
        width: '100px'
    },
    {
        text: 'Modelo',
        align: 'left',
        sortable: false,
        width: '100px'
    },
    {
        text: 'Qtd. Fornec.',
        align: 'left',
        sortable: false,
        width: '100px'
    },
    {
        text: 'Val. Ref. Unit.',
        align: 'right',
        sortable: false,
        value: 'valorReferencia',
        width: '100px'
    },
    {
        text: 'Val. Unit.',
        align: 'center',
        sortable: false,
        width: '150px'
    },
    {
        text: 'Val. Total',
        align: 'right',
        sortable: false,
        value: 'valorTotal',
        width: '100px'
    },
    {
        text: 'Anexos',
        align: 'center',
        sortable: false,
        width: '80px'
    }
]
